<template>
	<div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card>
        	<div slot="header">
            <i class="fa fa-edit"></i> {{ $t('str.manage-user') }}
            <div class="card-header-actions">
            	<router-link to="/account/user" class="card-header-action btn-setting">
			    			<buttons button-type="back"/>
		          </router-link>
            </div>
          </div>
          <b-form @submit.prevent="saveUser">
						<b-row>
	            <b-col sm="12">
								<table class="table">
									<tbody>
										<tr>
											<th scope="row">{{$t('str.first-name')}}</th>
											<td>
												<b-form-input type="text" name="first_name"
													:class="{ 'form-control':true, 'is-invalid':errors.has('first_name') }" id="first_name"
													v-validate="{ required:true }" v-model="addData.first_name"/>
	                			<span class="invalid-feedback">{{ errors.first('first_name') }}</span>
											</td>
										</tr>
										<tr>
											<th scope="row">{{$t('str.last-name')}}</th>
											<td>
												<b-form-input type="text" name="last_name"
													:class="{ 'form-control':true, 'is-invalid':errors.has('last_name') }" id="last_name"
													v-validate="{ required:true }" v-model="addData.last_name"/>
												<span class="invalid-feedback">{{ errors.first('last_name') }}</span>
											</td>
										</tr>
										<tr>
											<th scope="row">{{$t('str.business-type')}}</th>
											<td>
												<b-form-select name="business_type_select" v-model="business_type_select">
													<option :value="null">{{$t('str.choose-option')}}</option>
													<option value="Importer/Distributor">{{$t('str.importer-distributor')}}</option>
													<option value="Wholesaler">{{$t('str.wholesaler')}}</option>
													<option value="Retail Shop">{{$t('str.retail-shop')}}</option>
													<option value="Work Shop (Garage)">{{$t('str.workshop-garage')}}</option>
													<option value="User">{{$t('str.user')}}</option>
													<option value="Others">{{$t('str.others-please-state-if-others')}}</option>
												</b-form-select>
												<template v-if="business_type_select == 'Others'">
													<b-form-input type="text" class="form-control" id="business_type" v-model="addData.business_type" />
												</template>
											</td>
										</tr>
										<tr>
											<th scope="row">{{$t('str.email')}}</th>
											<td>
												<b-form-input type="email" name="email"
													:class="{ 'form-control':true, 'is-invalid':errors.has('email') }" id="email"
													v-validate="{ required:true }" v-model="addData.email"/>
	                			<span class="invalid-feedback">{{ errors.first('email') }}</span>
											</td>
										</tr>
										<tr>
											<th scope="row">{{$t('str.phone')}}</th>
											<td>
												<b-form-input type="text" name="phone"
													:class="{ 'form-control':true, 'is-invalid':errors.has('phone') }" id="phone"
													v-validate="{ required:true }" v-model="addData.phone"/>
												<span class="invalid-feedback">{{ errors.first('phone') }}</span>
											</td>
										</tr>
										<tr>
											<th scope="row">{{$t('str.country')}}</th>
											<td>
												<b-form-select name="country"
													:class="{ 'form-control':true, 'is-invalid':errors.has('country') }" id="country"
													:plain="true"
													v-validate="{ required:true }" v-model="addData.country_code">
													<option v-for="(cat, i) in countryListSelect" :value="cat.value" :key="i">{{cat.text}}</option>
												</b-form-select>
												<span class="invalid-feedback">{{ errors.first('country') }}</span>
											</td>
										</tr>
										<tr>
											<th scope="row">{{$t('str.language')}}</th>
											<td>
												<b-form-select name="language"
													:class="{ 'form-control':true, 'is-invalid':errors.has('language') }" id="language"
													:plain="true"
													v-validate="{ required:true }" v-model="addData.language">
													<template v-for="(lang, i) in langArr">
														<option :value="lang" :key="i">{{$t('str.'+lang)}}</option>
													</template>
												</b-form-select>
												<span class="invalid-feedback">{{ errors.first('language') }}</span>
											</td>
										</tr>
										<tr>
											<th scope="row">{{$t('str.role')}}</th>
											<td>
												<b-form-select name="business_type_select" v-validate="{required:true, numeric:true}" v-model="addData.rank">
													<option value="0">{{$t('str.normal-user')}}</option>
													<option value="1">{{$t('str.special-user')}}</option>
												</b-form-select>
												<!-- <b-form-input type="number" name="rank"
													:class="{ 'form-control':true, 'is-invalid':errors.has('rank') }" id="rank"
													v-validate="{ required:true, numeric:true }" v-model="addData.rank"/>
													<small>0 is Normal User, 1 is Special User</small> -->
												<span class="invalid-feedback">{{ errors.first('rank') }}</span>
											</td>
										</tr>
										<tr>
											<th scope="row">{{$t('str.password')}}</th>
											<td>
												<b-form-input type="password" name="password"
													:class="{ 'form-control':true, 'is-invalid':errors.has('password') }" id="password"
													v-model="addData.password"/>
												<span class="invalid-feedback">{{ errors.first('password') }}</span>
											</td>
										</tr>
										<tr>
											<th scope="row">{{$t('str.profile-pic')}}</th>
											<td>
												<b-form-file id="profile_pic" name="profile_pic" :plain="true" v-model="addData.profile_pic"></b-form-file>
			          			</td>
										</tr>
										<tr>
											<th v-if="profile_pic_url != null"></th>
											<td v-if="profile_pic_url != null">
												<img :src="`${profile_pic_url}`" style="width:100%;"/>
											</td>
										</tr>
                    <tr>
											<th scope="row">{{$t('str.platform')}}</th>
											<td>
												<b-form-select name="platform" v-validate="{required:true}" v-model="addData.platform">
                          <option value="">Select Device Platform</option>
													<option value="ios">{{$t('str.ios')}}</option>
													<option value="android">{{$t('str.android')}}</option>
												</b-form-select>
												<!-- <b-form-input type="number" name="rank"
													:class="{ 'form-control':true, 'is-invalid':errors.has('rank') }" id="rank"
													v-validate="{ required:true, numeric:true }" v-model="addData.rank"/>
													<small>0 is Normal User, 1 is Special User</small> -->
												<span class="invalid-feedback">{{ errors.first('rank') }}</span>
											</td>
										</tr>
									</tbody>
								</table>
	            </b-col>
	          </b-row>
            <b-row>
              <b-col cols="6">
                <buttons button-type="submit"/>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'

import Buttons from '@/views/component/Buttons'

export default {
  components: {
    'buttons': Buttons
  },
	data() {
		return {
			id: this.$route.params.id,
			langArr: [],
			countryList: [],
			countryListSelect: [],
			addData: {
				first_name:  '',
				last_name: '',
				email: '',
				phone: '',
				country_code: 'US',
				language: 'en',
				rank: '0',
				password: '',
				profile_pic: '',
				business_type: '',
        platform: '',
			},
			profile_pic_url: '',
			business_type_arr: ['Importer/Distributor','Wholesaler','Retail Shop','Work Shop (Garage)','User'],
			business_type_select: null,
			image_base_url: this.$helper.envi.VUE_APP_API_URL
		}
	},
	methods:{
		async getAllCountry() {
      this.$auth.checkSession()
  		try {
	  		var getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/User/Country`, {
					headers: { 'Authorization':`Bearer ${this.$auth.session.get().passport}` }
				})

				this.countryList = getData.data.data

				this.setCountryListSelect()
	  	} catch(e) {
	  		console.log(e.response)
	  	}
		},
		setCountryListSelect() {
			var catData = this.countryList
			catData.forEach((cd) => {
				this.countryListSelect.push({'value':cd.code, 'text':cd.name})
			})
		},
		async getUser() {
      this.$auth.checkSession()
  		var userId = this.id

  		if(userId > 0) {
  			try {
					var getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/User/${userId}`, {
						headers:{ 'Authorization':`Bearer ${this.$auth.session.get().passport}` }
					})

					this.addData.first_name = getData.data.data.first_name
					this.addData.last_name = getData.data.data.last_name
					this.addData.email = getData.data.data.email
					this.addData.phone = getData.data.data.phone
					this.addData.country_code = getData.data.data.country_code
					this.addData.language = getData.data.data.language
					this.addData.rank = getData.data.data.rank
					this.addData.business_type = getData.data.data.business_type
					if(this.business_type_arr.includes(getData.data.data.business_type)) this.business_type_select = getData.data.data.business_type
          this.addData.platform = getData.data.data.platform
					
					this.profile_pic_url = getData.data.data.image_url
			  } catch(e) {
			  	console.log('err', e.response)
					if(e.response) {
						this.$router.push('/pages/404')
					}
			  }
			}
		},
  	async saveUser() {
      this.$auth.checkSession()
  		if(this.$validator.validateAll()) {
	  		var method = 'post'
	  		var url = `${this.$helper.envi.VUE_APP_API_URL}/User/`

	  		var formData = new FormData()
	  		formData.append('first_name', this.addData.first_name)
	  		formData.append('last_name', this.addData.last_name)
	  		formData.append('email', this.addData.email)
	  		formData.append('phone', this.addData.phone)
	  		formData.append('country_code', this.addData.country_code)
				formData.append('language', this.addData.language)
				formData.append('rank', this.addData.rank)
        formData.append('platform', this.addData.platform)

				if(this.business_type_arr.includes(this.business_type_select))
					formData.append('business_type', this.business_type_select)
				else
					formData.append('business_type', this.addData.business_type)

	  		if(this.addData.password != '') {
	  			formData.append('password', this.addData.password)
	  		}

	  		if(this.addData.profile_pic) {
					formData.append('profile_pic', this.addData.profile_pic)
				}

	  		if(this.id > 0){
	  			method = 'patch'
	  			url = `${url}${this.id}`
	  		}

	  		try {
					var result = await axios[method](url, formData, {
						headers:{ 'Authorization':`Bearer ${this.$auth.session.get().passport}` }
					})

					this.$toast.success(result.data.meta.message, '', {
		        position:'topCenter'
					})

					if(this.id == 0)
						this.$router.push('/account/user')
				} catch(e) {
					if(Array.isArray(e.response.data.meta.error)) {
						e.response.data.meta.error.forEach((err) => {
							this.$toast.error(err.msg, e.response.data.meta.message, {
								position:'topCenter'
							})
						})
					} else if(typeof e.response.data.meta.error === 'string') {
						this.$toast.error(e.response.data.meta.message, e.response.data.meta.error, {
							position:'topCenter'
						})
					}
				}
			}
		}
  },
  async created(){
		this.langArr = await this.$api.getLangCodeArr()
  	this.getAllCountry()
  	this.getUser()
  }
}
</script>